export const Valores = () => {
  return <div>Valores</div>
}
